import { Tabs, Box } from "@radix-ui/themes";
import PriorityTab from "@/components/organisms/Global/Tabs/PriorityTab";
import TicketStatusTab from "./TicketStatusTab";
import ServiceTypeTab from "./ServiceTypeTab";
import NmqEntityTab from "./NmqEntityTab";
import LogCategoryTab from "./LogCategoryTab";
import InternalTicketTypeTab from "./InternalTicketTypeTab";
import SettingsTab from "./SettingsTab";
import { useEffect, useRef, useState } from "react";
import { TransferDataType } from "@/components/atoms/TransferList";
import useAccess from "@/hooks/useAccess";

type Props = {
  props: {
    [key: string]: any | TransferDataType[];
  };
  onTabChange?: (tab: string) => void;
};

const GlobalTabs = ({props, onTabChange = () => {}}: Props) => {
  const { getAccess } = useAccess();
  const tabRef = useRef(null);
  const [active, setActive] = useState("priorities");

  useEffect(() => {
    if (tabRef?.current)
      [...(tabRef?.current as any).children]
        .find((el: any) => el.dataset.state === "active")
        .scrollIntoView({
          inline: "center",
        });
  }, [active]);

  const handleTabChange = (e: string) => {
    setActive(e);
    onTabChange(e);
  };

  return (
    <Tabs.Root
      value={active}
      onValueChange={handleTabChange}
      className="global-tabs"
    >
      <Tabs.List className={"px-2"} ref={tabRef}>
        <Tabs.Trigger value="priorities">Priorities</Tabs.Trigger>
        <Tabs.Trigger value="ticketStatuses">Ticket Statuses</Tabs.Trigger>
        <Tabs.Trigger value="serviceTypes">Service Types</Tabs.Trigger>
        <Tabs.Trigger value="internalTicketTypes">Internal Ticket Types</Tabs.Trigger>
        <Tabs.Trigger value="nmqEntities">Nmq Entities</Tabs.Trigger>
        <Tabs.Trigger value="logCategories">Log Categories</Tabs.Trigger>
        <Tabs.Trigger value="settings">Settings</Tabs.Trigger>
      </Tabs.List>

      <Box>
        <Tabs.Content value="priorities">
          {getAccess(["listing_priorities"]) ? (
              <PriorityTab
                data={props.priorities}
                redirect_props={props?.redirect_props}
              />
            ) : (
              <span className="inline-flex items-center gap-2 text-gray-500 cursor-not-allowed text-center !block mt-32 text-lg">
                You are not authorized to view this content.
              </span>
            )}
        </Tabs.Content>

        <Tabs.Content value="ticketStatuses">
          {getAccess(["listing_ticket_statuses"]) ? (
              <TicketStatusTab
                data={props.ticket_statuses}
                redirect_props={props?.redirect_props}
              />
            ) : (
              <span className="inline-flex items-center gap-2 text-gray-500 cursor-not-allowed text-center !block mt-32 text-lg">
                You are not authorized to view this content.
              </span>
            )}
        </Tabs.Content>

        <Tabs.Content value="serviceTypes">
          {getAccess(["listing_service_types"]) ? (
              <ServiceTypeTab
                data={props.service_types}
                redirect_props={props?.redirect_props}
              />
            ) : (
              <span className="inline-flex items-center gap-2 text-gray-500 cursor-not-allowed text-center !block mt-32 text-lg">
                You are not authorized to view this content.
              </span>
            )}
        </Tabs.Content>

        <Tabs.Content value="internalTicketTypes">
          {getAccess(["listing_internal_ticket_types"]) ? (
              <InternalTicketTypeTab
                data={props.internal_ticket_types}
                redirect_props={props?.redirect_props}
              />
            ) : (
              <span className="inline-flex items-center gap-2 text-gray-500 cursor-not-allowed text-center !block mt-32 text-lg">
                You are not authorized to view this content.
              </span>
            )}
        </Tabs.Content>

        <Tabs.Content value="nmqEntities">
          {getAccess(["listing_nmq_entities"]) ? (
              <NmqEntityTab
                data={props.nmq_entities}
                redirect_props={props?.redirect_props}
              />
            ) : (
              <span className="inline-flex items-center gap-2 text-gray-500 cursor-not-allowed text-center !block mt-32 text-lg">
                You are not authorized to view this content.
              </span>
            )}
        </Tabs.Content>

        <Tabs.Content value="logCategories">
          {getAccess(["listing_log_categories"]) ? (
              <LogCategoryTab
                data={props.log_categories}
                redirect_props={props?.redirect_props}
              />
            ) : (
              <span className="inline-flex items-center gap-2 text-gray-500 cursor-not-allowed text-center !block mt-32 text-lg">
                You are not authorized to view this content.
              </span>
            )}
        </Tabs.Content>

        <Tabs.Content value="settings">
          {getAccess(["read_global_settings"]) ? (
              <SettingsTab
                data={props.settings}
                redirect_props={props?.redirect_props}
              />
            ) : (
              <span className="inline-flex items-center gap-2 text-gray-500 cursor-not-allowed text-center !block mt-32 text-lg">
                You are not authorized to view this content.
              </span>
            )}
        </Tabs.Content>
      </Box>
    </Tabs.Root>
  );
};

export default GlobalTabs;
